/**
 * LoginHero — left-panel content for AUTH-01 Login.
 *
 * Instrument Serif "Secure Labs" wordmark in Copper Sun, a 2-line tagline,
 * and four feature bullets with accent dot markers. Matches the Figma
 * frame 68:2 hero column (tree walker output captured in
 * docs/superpowers/phase-2-auth-refinement.md).
 */
const FEATURES = [
  'Visitor pre-authorisation',
  'Real-time QR validation',
  'Complete audit trail',
  'Multi-gate estate management',
];

export function LoginHero() {
  return (
    <div className="flex flex-col gap-6">
      <div
        className="text-5xl leading-none tracking-tight text-[var(--text-accent)] brand-name"
        style={{ fontFamily: 'var(--font-display)' }}
      >
        Secure Labs
      </div>
      <p className="text-lg leading-snug text-[var(--text-secondary)]">
        Estate Access Control
        <br />
        Built for security. Designed for living.
      </p>
      <ul className="mt-4 flex flex-col gap-3">
        {FEATURES.map((feature) => (
          <li
            key={feature}
            className="flex items-center gap-3 text-[15px] text-[var(--text-primary)]"
          >
            <span
              aria-hidden
              className="inline-block size-2 shrink-0 rounded-full bg-[var(--estate-accent)]"
            />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
}
